import { useState } from 'react'
import { useAbm } from '../hooks/useAbm'
import AbmTable from '../components/AbmTable'
import Modal from '../components/Modal'
import Boton from '../components/Boton'

const EMPTY = { nombre: '', activa: true }

export default function ZonasPage() {
  const { rows, loading, create, update, remove } = useAbm('zonas')
  const [modal, setModal] = useState(null)
  const [form, setForm] = useState(EMPTY)
  const [saving, setSaving] = useState(false)
  const [err, setErr] = useState('')

  const openCreate = () => { setForm(EMPTY); setErr(''); setModal('new') }
  const openEdit = (row) => { setForm({ nombre: row.nombre, activa: row.activa }); setErr(''); setModal(row) }

  const handleSave = async (e) => {
    e.preventDefault()
    setSaving(true)
    setErr('')
    try {
      if (modal === 'new') await create(form)
      else await update(modal.id, form)
      setModal(null)
    } catch (error) {
      setErr(error.response?.data?.message || 'Error al guardar')
    } finally {
      setSaving(false)
    }
  }

  const columns = [
    { key: 'nombre', label: 'Nombre' },
    { key: 'activa', label: 'Activa', render: v => v ? 'Sí' : 'No' },
  ]

  return (
    <div>
      <AbmTable
        title="Zonas"
        columns={columns}
        rows={rows}
        loading={loading}
        onCreate={openCreate}
        onEdit={openEdit}
        onDelete={remove}
      />
      {modal && (
        <Modal title={modal === 'new' ? 'Nueva Zona' : 'Editar Zona'} onClose={() => setModal(null)}>
          <form onSubmit={handleSave} style={styles.form}>
            <label style={styles.label}>Nombre</label>
            <input style={styles.input} value={form.nombre} onChange={e => setForm(f => ({ ...f, nombre: e.target.value }))} required />
            <label style={styles.checkRow}>
              <input type="checkbox" checked={form.activa} onChange={e => setForm(f => ({ ...f, activa: e.target.checked }))} />
              Activa
            </label>
            {err && <p style={styles.error}>{err}</p>}
            <div style={styles.actions}>
              <Boton variante="ghost" type="button" onClick={() => setModal(null)}>Cancelar</Boton>
              <Boton variante="primary" type="submit" disabled={saving}>{saving ? 'Guardando...' : 'Guardar'}</Boton>
            </div>
          </form>
        </Modal>
      )}
    </div>
  )
}

const styles = {
  form: { display: 'flex', flexDirection: 'column', gap: '0.75rem' },
  label: { fontWeight: '600', fontSize: '0.875rem', color: '#374151' },
  input: { padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.9375rem' },
  checkRow: { display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', cursor: 'pointer' },
  error: { color: '#dc2626', fontSize: '0.875rem', margin: 0 },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', marginTop: '0.5rem' },
}
